<template>
  <div class="chcard">
    <div class="chats col-3">
      <div class="label-search" style="padding: 10px; font-size: 16px;font-weight: 500;">Поиск контактов:</div>
      <div class="search ">
        <input autocomplete="off" name="search" placeholder="Поиск" v-model="search" @keyup="searchChat()">
        <img src="@/assets/img/worker/search.svg" alt="">
      </div>
      <!--<div class="chat" :class="{active: item.id == select_chat}" v-for="(item, idx1) in users" :key="idx1" @click="search_select = item.id; sendMessageUser(item.id);">
        <div class="avatar">
          <img class="chat-avatar" :src="getAvatar(item.avatar)" alt="">
          <div class="online" v-if="item.online"></div>
        </div>
        <div class="info">
          <div class="name">{{item.name}} {{item.surname}}</div>
          <div class="role">{{item.role}}{{item.role ? ',' : ''}} {{item.company_name}}</div>
        </div>
        <div class="date">
          <img v-if="item.status == 'send'" src="../assets/icons/chat/send.svg" alt="">
          <img v-if="item.status == 'read'" src="../assets/icons/chat/read.svg" alt="">
          {{item.date}}
        </div>
        <div class="new" v-if="item.messages">{{item.messages}}</div>
      </div>-->
      <div class="chat" :class="{active: item.id == select_chat}" v-for="(item, idx) in chats" :key="idx" @click="selectChat(item)">
        <div class="avatar">
          <img class="chat-avatar" :src="getAvatar(item.avatar)" alt="">
          <div class="online" v-if="item.online"></div>
        </div>
        <div class="info">
          <div class="name">{{item.name}} {{item.surname}}</div>
          <div class="role">{{item.role}}{{item.role ? ',' : ''}} {{item.company_name}}</div>
        </div>
        <div class="date">
          <img v-if="item.status == 'send'" src="../assets/icons/chat/send.svg" alt="">
          <img v-if="item.status == 'read'" src="../assets/icons/chat/read.svg" alt="">
          {{item.date}}
        </div>
        <div class="new" v-if="item.messages">{{item.messages}}</div>
      </div>
    </div>
    <div class="dialog col-9 h-100">
      <div class="wrp">
        <div class="header">
          <img class="chat-avatar" :src="getAvatar(avatar)" v-if="select_chat" alt="">
          <span v-if="select_chat">{{name}}</span>
          <div class="info" v-if="select_chat">
            <div class="role">{{role}}</div>
            <div class="circle"></div>
            <div class="company">{{company}}</div>
          </div>
        </div>
        <div class="messages" ref="dialogBlock">
          <loading-container :loading="loading" height="320">
            <div class="message" v-for="(item, idx) in dialog" :key="idx">
              <div v-if="item.date_day" style="display: flex;justify-content: center;">{{ item.date_day }}</div>
              <div class="new" v-if="item.new">{{item.new}}</div>
              <div class="message__body">
                <div class="avatar" v-if="!item.user"><img class="chat-avatar" :src="getAvatar(avatar)" alt=""></div>
                <div class="text" :class="{user: item.user, error: !item.send}">
                    {{item.text}}
                    <div v-if="!item.user" style="font-size: 12px; display: flex; justify-content: flex-end;">{{ $moment(item.date_creat).format('h:mm')  }}</div>
                    <div v-if="item.user" style="font-size: 12px; display: flex; justify-content: flex-start;">{{ $moment(item.date_creat).format('h:mm')  }}</div>
                </div>
                <div class="avatar" v-if="item.user"><img class="chat-avatar" :src="getAvatar(you_avatar)" alt=""></div>
              </div>
              <div class="adds" :class="{'right-files': item.user}">
                <div class="add"
                     v-for="(AddItem, idx) in item.adds"
                     :key="idx"
                >
                  <img src="../assets/icons/chat/doc.svg" alt="">
                  <a class="file-url" target="_blank" :href="AddItem.url">{{AddItem.name}}</a>
                </div>
              </div>
            </div>
          </loading-container>
        </div>
        <div class="input">
          <img src="../assets/icons/chat/paperclip.svg" @click="fileInput" alt="" class="add">
          <input autocomplete="off" type="text" v-model="message" v-on:keyup.enter="send()" placeholder="Введите сообщение">
          <img src="../assets/icons/chat/sent.svg" alt="" class="send" @click="send()">
          <input type="file" ref="file" hidden @change="onFileChange">
        </div>
        <div class="upload-files-block" v-for="(item, idx) in upload_files" :key="'upload_files-' + idx">
          <div class="file-name"> <img src="../assets/icons/chat/doc.svg" alt=""> {{item.name}}</div>
          <div class="upload-file-status" v-if="item.upload">
            <div class="loader-block"><app-loader :loaderHeight="20" :loaderWidth="20"></app-loader></div>
          </div>
        </div>
      </div>



    </div>
  </div>
</template>

<script>

import echo from '../socket'
import LoadingContainer from "@/components/loading-container";
import AppLoader from "@/components/app-loader";

export default {
  name: "chat",
  components: {
    LoadingContainer,
    AppLoader
  },
  data: ()=>({
    chats:[
      /*{
        avatar: require('../assets/img/main/avatar.png'),
        name: 'Кристина Стержнева',
        role: 'Менеджер',
        status: 'send',
        date: '25 сен.'

      },
      {
        avatar: require('../assets/img/main/avatar.png'),
        name: 'Кристина Стержнева',
        role: 'Менеджер',
        status: 'read',
        date: '25 сен.',
        messages: 3,
        online: true,
        active: true
      },
      {
        avatar: require('../assets/img/main/avatar.png'),
        name: 'Кристина Стержнева',
        role: 'Менеджер',
        status: 'send',
        date: '25 сен.'

      },
      {
        avatar: require('../assets/img/main/avatar.png'),
        name: 'Кристина Стержнева',
        role: 'Менеджер',
        status: 'read',
        date: '25 сен.',
        messages: 3,
        online: true,
      },
      {
        avatar: require('../assets/img/main/avatar.png'),
        name: 'Кристина Стержнева',
        role: 'Менеджер',
        status: 'send',
        date: '25 сен.'

      },
      {
        avatar: require('../assets/img/main/avatar.png'),
        name: 'Кристина Стержнева',
        role: 'Менеджер',
        status: 'read',
        date: '25 сен.',
        messages: 3,
        online: true,
      },
      {
        avatar: require('../assets/img/main/avatar.png'),
        name: 'Кристина Стержнева',
        role: 'Менеджер',
        status: 'send',
        date: '25 сен.'

      },
      {
        avatar: require('../assets/img/main/avatar.png'),
        name: 'Кристина Стержнева',
        role: 'Менеджер',
        status: 'read',
        date: '25 сен.',
        messages: 3,
        online: true,
      },
      {
        avatar: require('../assets/img/main/avatar.png'),
        name: 'Кристина Стержнева',
        role: 'Менеджер',
        status: 'send',
        date: '25 сен.'

      },
      {
        avatar: require('../assets/img/main/avatar.png'),
        name: 'Кристина Стержнева',
        role: 'Менеджер',
        status: 'read',
        date: '25 сен.',
        messages: 3,
        online: true,
      },
      {
        avatar: require('../assets/img/main/avatar.png'),
        name: 'Кристина Стержнева',
        role: 'Менеджер',
        status: 'send',
        date: '25 сен.'

      },
      {
        avatar: require('../assets/img/main/avatar.png'),
        name: 'Кристина Стержнева',
        role: 'Менеджер',
        status: 'read',
        date: '25 сен.',
        messages: 3,
        online: true,
      },
      {
        avatar: require('../assets/img/main/avatar.png'),
        name: 'Кристина Стержнева',
        role: 'Менеджер',
        status: 'send',
        date: '25 сен.'

      },
      {
        avatar: require('../assets/img/main/avatar.png'),
        name: 'Кристина Стержнева',
        role: 'Менеджер',
        status: 'read',
        date: '25 сен.',
        messages: 3,
        online: true,
      },*/
    ],
    dialog:[
      /*{
        user: false,
        text: 'Рондо, как и в других отраслях российского права, безвозмездно.Сделка, как бы это ни казалось парадоксальным, синхронно арендует тетрахорд, что часто служит основанием изменения и прекращения гражданских прав и обязанностей. Пуанта иллюстрирует дорийский аккредитив. ',
      },
      {
        user: true,
        text: 'Рондо, как и в других отраслях российского права, безвозмездно.Сделка, как бы это ни казалось парадоксальным, синхронно арендует тетрахорд, что часто служит основанием изменения и прекращения гражданских прав и обязанностей. Пуанта иллюстрирует дорийский аккредитив. ',
      },
      {
        user: false,
        text: 'Рондо, как и в других отраслях российского права, безвозмездно.Сделка, как бы это ни казалось парадоксальным, синхронно арендует тетрахорд, что часто служит основанием изменения и прекращения гражданских прав и обязанностей. Пуанта иллюстрирует дорийский аккредитив. ',
      },
      {
        user: false,
        text: 'Рондо, как и в других отраслях российского права, безвозмездно.Сделка, как бы это ни казалось парадоксальным, синхронно арендует тетрахорд, что часто служит основанием изменения и прекращения гражданских прав и обязанностей. Пуанта иллюстрирует дорийский аккредитив. ',
      },
      {
        user: true,
        text: 'Рондо, как и в других отраслях российского права, безвозмездно.Сделка, как бы это ни казалось парадоксальным, синхронно арендует тетрахорд, что часто служит основанием изменения и прекращения гражданских прав и обязанностей. Пуанта иллюстрирует дорийский аккредитив. ',
      },
      {
        user: false,
        text: 'Рондо, как и в других отраслях российского права, безвозмездно.Сделка, как бы это ни казалось парадоксальным, синхронно арендует тетрахорд, что часто служит основанием изменения и прекращения гражданских прав и обязанностей. Пуанта иллюстрирует дорийский аккредитив. ',
      },
      {
        user: false,
        text: 'Рондо, как и в других отраслях российского права, безвозмездно.Сделка, как бы это ни казалось парадоксальным, синхронно арендует тетрахорд, что часто служит основанием изменения и прекращения гражданских прав и обязанностей. Пуанта иллюстрирует дорийский аккредитив. ',
      },
      {
        user: false,
        text: 'Рондо, как и в других отраслях российского права, безвозмездно.Сделка, как бы это ни казалось парадоксальным, синхронно арендует тетрахорд, что часто служит основанием изменения и прекращения гражданских прав и обязанностей. Пуанта иллюстрирует дорийский аккредитив. ',
      },
      {
        user: false,
        text: 'Рондо, как и в других отраслях российского права, безвозмездно.Сделка, как бы это ни казалось парадоксальным, синхронно арендует тетрахорд, что часто служит основанием изменения и прекращения гражданских прав и обязанностей. Пуанта иллюстрирует дорийский аккредитив. ',
      },
      {
        user: true,
        text: 'Рондо, как и в других отраслях российского права, безвозмездно.Сделка, как бы это ни казалось парадоксальным, синхронно арендует тетрахорд, что часто служит основанием изменения и прекращения гражданских прав и обязанностей. Пуанта иллюстрирует дорийский аккредитив. ',
      },
      {
        user: false,
        text: 'Рондо, как и в других отраслях российского права, безвозмездно.Сделка, как бы это ни казалось парадоксальным, синхронно арендует тетрахорд, что часто служит основанием изменения и прекращения гражданских прав и обязанностей. Пуанта иллюстрирует дорийский аккредитив. ',
      },
      {
        user: false,
        text: 'Рондо, как и в других отраслях российского права, безвозмездно.Сделка, как бы это ни казалось парадоксальным, синхронно арендует тетрахорд, что часто служит основанием изменения и прекращения гражданских прав и обязанностей. Пуанта иллюстрирует дорийский аккредитив. ',
        new: '1 новое сообщение',
        adds: [
          {
            icon: require('../assets/icons/chat/doc.svg'),
            name: 'Договор на подписание.doc'
          },
          {
            icon: require('../assets/icons/chat/doc.svg'),
            name: 'Приложение.doc'
          }

        ]
      },*/
    ],
    avatar: '',
    you_avatar: '',
    name: '',
    role: '',
    company: '',
    select_chat: '',
    message: '',
    company_id: '',
    loading: false,
    search: '',
    send_message: 1,
    file: '',
    files: [],
    upload_files: [],
    users: [],
    search_select: null,
    user_id:null,
    t: null,
    chat_user_id: '',
    admin_chat: false
  }),
  mounted() {
    if(this.$route.query.company) {
      this.company_id = this.$route.query.company;
      this.sendMessage(this.company_id);
    }

    if(this.$route.query.user) {
      this.user_id = this.$route.query.user;
    }

    if(this.$route.query.admin) {
      this.admin_chat = this.$route.query.admin ? true : false;
    }

    this.getChats();
    echo.private('chat.' + localStorage.getItem('token'))
      .listen('.new.message', (e) => {
        if (this.$route.name == 'chat') {
          if (e.chat == this.select_chat) {
            this.dialog.push({
              user: false,
              text: e.message.message,
              send: true,
              adds: e.message.files
            });
            this.readMessages();
          } else {
            for (let key in this.chats) {
              if (this.chats[key].id == e.chat) {
                this.chats[key].messages++;
              }
            }
          }
        }
    });
  },
  updated(){
    this.scrollBlock();
  },
  destroyed(){
    this.select_chat = '';
  },
  methods: {
    send() {
      let upload = false;
      if (this.upload_files.length > 0) {
        for (let key in this.upload_files) {
          if (this.upload_files[key].upload) {
            upload = true;
          }
        }
      }
      if (this.message && this.select_chat && !upload) {
        let id = this.send_message;
        let message = this.message;
        let files = this.files;
        this.send_message++;

        this.dialog.push({
          user: true,
          text: this.message,
          id: id,
          send: true,
          adds: this.files
        });

        this.message = '';
        this.files = [];
        this.upload_files = [];

        this.$http.post('/create-chat-message', {
          token: localStorage.getItem('token'),
          message: message,
          chat: this.select_chat,
          files: files,
          user_id: this.chat_user_id
        }).then(({data})=> {
          if (data.error) {
            for (let key in this.dialog) {
              if (this.dialog[key].id && this.dialog[key].id == id) {
                /*this.dialog.splice(key, 1);*/
                this.dialog[key].send = false;
              }
            }
          }

          if (data.chat) {
            let chat = this.select_chat;
            if (this.select_chat == 'admin' || this.chat_user_id) {
              this.select_chat = data.chat;
              this.chat_user_id = '';
            }
            for (let key in this.chats) {
              if (this.chats[key].id == 'admin' || chat == this.chats[key].id) {
                this.chats[key].id = data.chat;
              }
            }
          }
        })
        .catch((error) => {
          for (let key in this.dialog) {
            if (this.dialog[key].id && this.dialog[key].id == id) {
              this.dialog[key].send = false;
            }
          }
            console.log(error)
        })
      }
    },
    searchChat(){
      if(this.t)clearTimeout(this.t)
      this.t = setTimeout(()=>{
        this.getChats();
      },1000)
      /*this.$http.post('/get-chats', {
        token: localStorage.getItem('token'),
        search:this.search,
      }).then(({data}) => {
        console.log('data',data)
          this.users = data.users;
      }).catch((error) => {
        console.log(error)
      })*/
    },
    getChats() {
      this.dialog = [];
      this.select_chat = '';
      this.$http.post('/get-chats', {
        token: localStorage.getItem('token'),
        search:this.search,
      }).then(({data})=> {
        if (data.chats) {
          this.chats = data.chats
          for (let key in this.chats) {
            if (this.chats[key].company && this.company_id && this.chats[key].company == this.company_id) {
              this.selectChat(this.chats[key]);
            }
            if (this.chats[key].user_id && this.user_id && this.chats[key].user_id == this.user_id) {
              this.selectChat(this.chats[key]);
            }

            if (this.admin_chat && (this.chats[key].id == 'admin' || this.chats[key].user_id == 1)) {
              this.selectChat(this.chats[key]);
            }
          }
        }
      })
      .catch((error) => {
          console.log(error)
      })
    },
    readMessages() {
      this.$http.post('/read-chat-messages', {
        token: localStorage.getItem('token'),
        chat: this.select_chat
      }).then(()=> {

      })
      .catch((error) => {
          console.log(error)
      })
    },
    getMessages() {
      this.loading = true;
      this.$http.post('/get-chat-messages', {
        token: localStorage.getItem('token'),
        chat: this.select_chat
      }).then(({data})=> {
        let read = false;
        data.messages.data.reverse();
        for (let key in data.messages.data) {
          if (data.messages.data[key].interlocutor != data.user_id) {
            if (!data.messages.data[key].read && !read) {
              read = true;
              this.dialog.push({
                new: 'Новые сообщения',
                user: false,
                text: data.messages.data[key].message,
                date_creat: data.messages.data[key].created_at,
                send: true,
                adds: data.messages.data[key].files ? data.messages.data[key].files : []
              });
            } else {
              this.dialog.push({
                user: false,
                text: data.messages.data[key].message,
                date_creat: data.messages.data[key].created_at,
                send: true,
                adds: data.messages.data[key].files ? data.messages.data[key].files : []
              });
            }
          } else {
            this.dialog.push({
              user: true,
              text: data.messages.data[key].message,
              date_creat: data.messages.data[key].created_at,
              send: true,
              adds: data.messages.data[key].files ? data.messages.data[key].files : []
            });
          }
        }
        var flag = '';
        for (let key in this.dialog) {
          if (this.$moment(this.dialog[key].date_creat).format('DDMM') != flag){
            flag = this.$moment(this.dialog[key].date_creat).format('DDMM')
            this.dialog[key].date_day =  this.$moment(this.dialog[key].date_creat).format('DD MMMM');
          }else {
            this.dialog[key].date_day = false;
          }
        }

        for (let key in this.chats) {
          if (this.chats[key].id == this.select_chat) {
            this.chats[key].messages = 0;
          }
        }
      })
      .catch((error) => {
          console.log(error)
      })
      .finally(() => this.loading = false)
    },
    selectChat(item) {
      if (item.id != this.select_chat) {
        this.dialog = [];
        this.avatar = item.avatar;
        this.you_avatar = item.my_avatar;
        this.name = item.name;
        this.company = item.company_name;
        this.role = item.role;
        this.select_chat = item.id;
        if (!Number.isInteger(item.id)) {
          this.chat_user_id = item.user_id;
        } else {
          this.chat_user_id = '';
        }
        if (item.id != 'admin' || !this.$route.query.company) {
          this.getMessages();
        }
      }
    },
    scrollBlock() {
      var dialogBlock = this.$refs.dialogBlock;
      dialogBlock.scrollTop = dialogBlock.scrollHeight;
    },
    onFileChange(e) {
      this.file = e.target.files[0];
      let id = this.upload_files.length;
      console.log(this.file);
      this.upload_files.push({
        icon: this.file_icon,
        name: this.file.name,
        upload: true,
        id: id
      });
      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('token', localStorage.getItem('token'));
      this.$http.post( '/upload-chat-file',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }
      ).then((response) => {
        if (response.data.url) {
          let name = '';
          for (let key in this.upload_files) {
            if (this.upload_files[key].id == id) {
              this.upload_files[key].upload = false;
              name = this.upload_files[key].name;
            }
          }
          this.files.push({
            name: name,
            url: response.data.url
          });
        }
      }).catch(() => {
          this.$toast.error('Ошибка!');
      })
    },
    fileInput() {
      if (this.select_chat) {
        this.$refs.file.click();
      }
    },
    getAvatar (avatar){
      if(avatar == 'https://api.superbaer24.ru/storage/') return require('../assets/icons/user.svg')
      else return avatar
    },
    sendMessage(id) {
      // if (this.search_select){
      //   this.$router.push('/chat?company='+this.search_select)
      //   location.reload()
      // }
      if (localStorage.getItem('token')) {
        this.$http.post('/create-chat', {
          token: localStorage.getItem('token'),
          id: id,
        }).then(({data}) => {
          if (data.success) {
            this.getChats();
          }
        })
            .catch((error) => {
              console.log(error)
            })
      }
    },
    sendMessageUser(id) {
      if (this.search_select){
        this.$router.push('/chat?user='+this.search_select)
      }
      this.user_id = this.search_select;
      if (localStorage.getItem('token')) {
        this.$http.post('/create-chat-user', {
          token: localStorage.getItem('token'),
          id: id,
        }).then(({data}) => {
          if (data.success) {
            this.getChats();
          }
        })
            .catch((error) => {
              console.log(error)
            })
      }
    },
  }
}
</script>

<style scoped lang="scss">
.upload-files-block {
  background-color: #EEF0F3;
  padding: 4px 10px 10px 4px;
  font-size: 14px;
}

.chat-avatar {
  border: 1px solid #2CB181;
  border-radius: 50%;
}

.file-url {
  font-size: 14px;
}

.upload-file-status, .file-name {
  display: inline-block;
}

.upload-file-status {
  position: relative;
}

.loader-block {
  position: absolute;
  top: -16px;
  right: -28px;
}

.right-files {
  justify-content: flex-end;
  margin-right: 60px;
}
.chcard{

  display: flex;
  align-items: flex-start;
  width: 100%;

  .chats{
    padding: 0;
    overflow-y: scroll;
    scroll-behavior: smooth;
    height: calc(100vh - 50px);
    &::-webkit-scrollbar {
      display: none!important;
    }
    .chat{
      position: relative;
      cursor: pointer;
      display: flex;
      width: 100%;
      padding: 20px 10px 20px 20px;
      background: #FFFFFF;
      border-right: 1px solid #EEF0F3;
      border-bottom: 1px solid #EEF0F3;
      &.active{
        background: #F9F9FB;
        cursor: unset;
      }
      .avatar{
        margin-right: 10px;
        position: relative;
        height: max-content;
        img{
          height: 40px;
          width: 40px;
        }
        .online{
          right: 1px;
          bottom: 2px;
          position: absolute;
          height: 8px;
          width: 8px;
          background: #2cb181;
          border: 1px solid white;
          border-radius: 50%;
        }
      }
      .info{
        display: flex;
        flex-direction: column;
        justify-content: center;
        .name{
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 16px;
          color: #2D3137;
          margin-bottom: 3px;
        }
        .role{
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 14px;
          color: #636974;
        }
      }
      .date{
        display: flex;
        align-items: center;
        margin-left: auto;
        margin-top: auto;
        font-style: normal;
        font-weight: normal;
        font-size: 11px;
        line-height: 11px;
        color: #636974;
        img{
          margin-right: 5px;
        }
      }
      .new{
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        font-style: normal;
        font-weight: bold;
        font-size: 9px;
        line-height: 10px;
        color: #FFFFFF;
        right: 10px;
        top: 10px;
        height: 16px;
        width: 16px;
        background: #F39220;
        border-radius: 50%;
      }
    }
  }
  .dialog{
    height: calc(100vh - 50px);
    padding: 30px;
    .wrp{
      padding: 2px;
      width: 100%;
      background: #FFFFFF;
      box-shadow: 0px 0px 3px #E5E5EA;
      border-radius: 4px;
      .header{
        z-index: 2;
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        background: #FFFFFF;
        box-shadow: 0px 0px 30px rgba(129, 129, 129, 0.25);
        border-radius: 4px;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #000000;
        img{
          height: 40px;
          width: 40px;
          margin-right: 15px;
          margin-left: 10px;
        }

        .info{
          display: flex;
          align-items: center;
          margin-left: auto;
          margin-right: 20px;
          font-weight: normal;
          font-size: 14px;
          line-height: 16px;
          color: #2D3137;
          .circle{
            margin: 0 10px;
            height: 3px;
            width: 3px;
            background: #B6BCC8;
            border-radius: 50%;
          }
          .company{
            cursor: default;
            text-decoration-line: underline;
          }
        }
      }
      .messages{
        height: calc(100vh - 220px);
        width: 100%;
        overflow-y: scroll;
        z-index: 1;
        padding: 15px;
        .message{
          margin-bottom: 20px;
          .new{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 20px;
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            color: #636974;
          }
          &__body{
            display: flex;
            align-items: center;
            width: 100%;
            .avatar{
              width: max-content;
              height: max-content;
              margin: 0 15px auto 15px;
              img{
                width: 32px;
                height: 32px;
              }
            }
            .text{
              font-style: normal;
              font-weight: normal;
              font-size: 14px;
              line-height: 20px;
              color: #2D3137;
              padding: 15px;
              background: #EEF0F3;
              border-radius: 0px 24px 24px 24px;
              max-width: 70%;
              &.user{
                margin-left: auto;
                background: #2CB181;
                box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.24), 0px 2px 4px rgba(0, 0, 0, 0.16), 0px -1px 1px rgba(0, 0, 0, 0.08);
                border-radius: 24px 0px 24px 24px;
                color: #FFFFFF;
              }
              &.error{
                 background: red;
               }

            }
          }
          .adds{
            display: flex;
            align-items: center;
            margin-left: 45px;
            margin-top: 5px;
            .add{
              cursor: pointer;
              margin-left: 20px;
              img{
                margin-right: 5px;
              }
            }

          }
        }
      }
      .input{
        position: relative;

        width: 100%;
        height: 50px;
        background: #EEF0F3;
        border-radius: 4px;
        display: flex;
        align-items: center;
        .add{
          margin: 0 15px;
        }
        input{
          padding-left: 15px;
          height: 40px;
          width: 100%;
          background: #FFFFFF;
          border: 1px solid #EEF0F3;
          box-sizing: border-box;
          border-radius: 4px;
          margin-right: 5px;
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 14px;
          color: black;
          &:placeholder-shown{
            color: #636974;
          }
        }
        .send{
          cursor: pointer;
          right: 20px;
          position: absolute;
        }
      }
    }

  }
  .search {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: flex-end;

    > input {
      border: 1px solid #EEF0F3;
      box-sizing: border-box;
      border-radius: 4px;
      width: 100%;
      height: 40px;
      padding: 0 40px 0 15px;
      outline: none;

      &:focus{
        border: 1px solid #2CB181;
      }
    }

    > img {
      position: absolute;
      right: 15px;
      bottom: 50%;
      transform: translateY(50%);
      width: 14px;
      height: 14px;
      cursor: pointer;
    }
  }
}
</style>